import { Dialog, styled } from "@mui/material";
import { IEmbed } from "../../embedsV2/interface";

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(1),
    height: "70vh",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width: "100%",
    maxWidth: "950px",
  },
}));

export const SubmitBtnStyle = {
  color: "#fff",
  background: "#976006",
  borderRadius: 1,
  padding: "10px 20px",
  ":hover": { backgroundColor: "#7b4e04" },
  ":focus": { backgroundColor: "#7b4e04" },
  ":disabled": { backgroundColor: "#888", color: "#fff" },
};

export interface ICreateEmbed extends IEmbed {
  shopability?: {
    enabled?: string;
    text?: string;
    startTime?: string;
    targetClass?: string;
    targetUrl?: string;
    position?: string;
  };
  colors?: {
    bgColor?: string;
    textColor?: string;
    titleColor?: string;
    navigationColor?: string;
  };
}
